import { useQueryClient } from '@tanstack/react-query';
import { useMutationState } from '~/hooks/reactQuery/useMutationState';
import { useStoreActions } from '~/store/store-context';
import { matchDismissalUndo, settleUndos } from '~/utils/revenueOpportunities/opportunityDismissals';
import { revenueOpportunitiesSummaryKey } from '~/utils/revenueOpportunities/revenueOpportunitiesQueryKeys';
export const useUndoRevenueOpportunityDismissal = ()=>{
    const { api } = useStoreActions();
    const queryClient = useQueryClient();
    const { mutateAsync } = useMutationState({
        mutationFn: (param)=>{
            let { undos } = param;
            return Promise.allSettled(undos.map(sendUndo)).then((results)=>settleUndos(undos, results));
        },
        onSuccess: (param, param1)=>{
            let { mayHaveChanged } = param, { businessId } = param1;
            if (mayHaveChanged) {
                queryClient.invalidateQueries({
                    queryKey: revenueOpportunitiesSummaryKey(businessId)
                });
            }
        }
    });
    function sendUndo(undo) {
        return matchDismissalUndo(undo, {
            single: (dismissalId)=>api.pulse.deleteDismissal(dismissalId),
            batch: (body)=>api.pulse.removeDismissals(body)
        });
    }
    return {
        undoRevenueOpportunityDismissal: mutateAsync
    };
};
